/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    }); 
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  var local_province_range = localStorage.getItem("ProvinceValue");

  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
    if (this.isShow) {
        var searchTerm = Utils.stripHtml(Globals.currentTerm);
        // Product image
        var imageHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
            imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
            imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
        }
        // Product title
        var productTitle = this.customizeProductTitle();
        productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
        // SKU
        var skuHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
            skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
            skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
        }
        // Vendor
        var vendorHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
            vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
            vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
        }
        // Price
        var priceHTML = this.compileSuggestionProductPrice();
        // Open the result item in new tab when selected
        var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
     

        var timeStampInMs = Date.now();
         var search_pro_url = this.url + '?prov='+ local_province_range + '&view='+ timeStampInMs;
        
 
        return this.getTemplate()
            .replace(/{{id}}/g, this.id)
            .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
            .replace(/{{url}}/g, search_pro_url.replace('collections//products','products').replace('collections/all/products','products'))
            .replace(/{{newTabAttribute}}/g, newTabAttr)
            .replace(/{{itemProductImage}}/g, imageHTML)
            .replace(/{{title}}/g, productTitle)
            .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
            .replace(/{{itemProductSku}}/g, skuHTML)
            .replace(/{{itemProductVendor}}/g, vendorHTML)
            .replace(/{{itemProductPrice}}/, priceHTML)
            .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
            .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
            .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
      } else {
          return '';
      }
  }

  InstantSearchMobile.prototype.beforeRender = function() {
    var buttonClass = '.mobile__icon-list [aria-controls="search-drawer"]' // Search icon
      const searchDrawer = document.querySelector('.search-drawer')
  
    var self = this;
    var $button = jQ(buttonClass);
  
    var clone = $button.clone();  
  
          window.addEventListener('resize', function () {
  
        if(Utils.isMobile()) {
          clone.on('click',function(e) {
      e.stopPropagation();
      e.preventDefault();
      self.openSuggestionMobile()
        document.querySelector('.boost-pfs-search-suggestion-mobile-overlay').style.display = 'fixed';
    });
      }else {
          clone.on('click',function(e) {
      searchDrawer.style.visibility = 'visible'
      searchDrawer.style.right = '0px'
      searchDrawer.style.top = '0px'
      searchDrawer.style.opacity = '1'
      searchDrawer.setAttribute('open', '')
        document.querySelector('.boost-pfs-search-suggestion-mobile-overlay').style.display = 'none';
    });
        }
  }) 
  
         clone.on('click',function(e) {
      e.stopPropagation();
      e.preventDefault();
      self.openSuggestionMobile()
    });
          $button.replaceWith(clone); 
  
  }
  
    InstantSearchMobile.prototype.afterShowSearchBoxMobile = function() {
      this.searchBox.$element.focus()
    }
  
})();
